import {
  UpdateAddressInput,
  UpdateAddressOutput,
} from "@redotech/redo-model/order-editing/schemas/update-address";

export const updateAddressSelfServe = {
  name: "updateAddressSelfServe" as const,
  input: UpdateAddressInput,
  output: UpdateAddressOutput,
};
